import styles from './radio.module.scss';
import { ChangeEvent, ReactNode } from 'react';
import MaterialRadio from '@mui/material/Radio';
import RadioGroup from '../radio-group/radio-group';
import MaterialFormControlLabel from '@mui/material/FormControlLabel';


/* eslint-disable-next-line */
export interface RadioProps {
  checked?: boolean,
  // checkedIcon?: ReactNode,
  // classes?: object,
  color?: 'default' | 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning'
  disabled?: boolean,
  // disableRipple?: boolean,
  // icon?: ReactNode,
  // id?: string,
  // inputProps?: object,
  // inputRef?: any,
  name?: string,
  onChange?: (event: ChangeEvent, checked: boolean) => void,
  // required?: boolean,
  size?: 'medium' | 'small',
  sx?: any,
  value?: any,
  className?: string,
  label?: any
}

export function Radio(props: RadioProps) {
  return (
    <MaterialRadio
      onChange={props.onChange}
      checked={props.checked}
      name={props.name}
      value={props.value}
      disabled={props.disabled}
      size={props.size}
      className={props.className}
    />
  );
}

export function RadioLabel(props: RadioProps) {
  return (
    <RadioGroup>
      <MaterialFormControlLabel
        control={<Radio {...props} />}
        label={props.label}
      />
    </RadioGroup>
  );
}

export default Radio;